module.exports = __webpack_public_path__ + "img/034-attractive.11634ab5.svg";